module.exports = __webpack_public_path__ + "img/cats4.60e99662.jpg";